
























































































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator';
import TableMixin from '@/common/mixins/table';
import TableWidthMixin from '@/common/mixins/table-width';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import BarLine from './components/bar-line.vue';
import RightTop from './components/right-top.vue';
import { abnormalOverview, abnormalParkRanking, abnormalDetail, abnormalTrend } from '@/api/statistic-analysis/index';
import moment from 'moment';
@Component({
  name: 'AbnormalOperation',
  components: {
    ParkingLotSearch,
    BarLine,
    RightTop
  }
})
export default class AbnormalOperation extends Mixins(TableMixin, TableWidthMixin) {
  filterParam: any = {
    startTime: '',
    endTime: '',
    parkIds: ''
  };
  // 选择的车场
  selectParkIds: Array<string> = [];
  timeQuickButtons: any[] = [
    { value: '01', text: '近7天' },
    { value: '02', text: '近1月' },
    { value: '03', text: '自定义' }
  ];
  //chart 数据
  statisticsData: any = [];
  // 选择的时间范围
  timeRangeType: String = '01';
  // 自定义时间
  customTime: any[] = [];
  exit: number = 0; //总出场流量
  handLift: string = ''; //手动抬杆百分比
  handLiftNum: number = 0; //手动抬杆数量
  inAndOut: number = 0; //总流量
  plateRevise: string = ''; //车辆修正百分比
  plateReviseNum: number = 0; //车辆修正数量
  specialPass: string = ''; //特殊放行百分比
  specialPassNum: number = 0; //特殊放行数量
  freeCount: string = ''; //免费放行百分比
  freeCountNum: number = 0; //免费放行数量

  //排名列表
  // rankList: any[] = []
  // rankLoading: boolean = false
  //table数据
  tableData: any[] = [];
  tableLoading: boolean = false;
  trendLoading: boolean = false;
  //table列表
  get tableColums() {
    return [
      {
        title: '序号',
        width: 120,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '日期',
        dataIndex: 'orderDay',
        width: 180
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '总进场次数',
        dataIndex: 'enterCount',
        width: 180
      },
      {
        title: '总出场次数',
        dataIndex: 'exitCount',
        width: 160
      },
      {
        title: '总手动抬杆次数',
        dataIndex: 'handelCount',
        width: 160,
        scopedSlots: { customRender: 'handlift' }
      },
      {
        title: '总手动抬杆率',
        dataIndex: 'handelRate',
        width: 160,
        customRender: v => {
          if (v === '') {
            return '--';
          } else {
            return v + '%';
          }
        }
      },
      {
        title: '总出场特殊放行次数',
        dataIndex: 'specialCount',
        width: 180,
        scopedSlots: { customRender: 'fangxing' }
      },
      {
        title: '总出场特殊放行率',
        dataIndex: 'specialRate',
        width: 160,
        customRender: v => {
          if (v === '') {
            return '--';
          } else {
            return v + '%';
          }
        }
      },
      {
        title: '总免费放行出场次数',
        dataIndex: 'freeCount',
        width: 180
      },
      {
        title: '总免费放行出场率',
        dataIndex: 'freeRate',
        width: 160,
        customRender: v => {
          if (v === '') {
            return '--';
          } else {
            return v + '%';
          }
        }
      },
      {
        title: '总车辆修正次数',
        dataIndex: 'updateCount',
        width: 160,
        scopedSlots: { customRender: 'xiuzheng' }
      },
      {
        title: '总车辆修正率',
        dataIndex: 'updateRate',
        width: 160,
        customRender: v => {
          if (v === '') {
            return '--';
          } else {
            return v + '%';
          }
        }
      }
    ];
  }
  //图表时间范围
  trendTimeRange: string[] = [];
  //图表柱形图数据
  barData: any = {
    handLift: [],
    special: [],
    repair: [],
    free: []
  };
  //图表折线图数据
  lineData: any = {
    handLift: [],
    special: [],
    repair: [],
    free: []
  };
  //时间发生变化的回调
  onCustomTimeChange(date: any, dateString: any) {
    let [startTime, endTime] = date;
    if (startTime) {
      this.filterParam.startTime = startTime.startOf('day').format('YYYY-MM-DD');
    }
    if (endTime) {
      this.filterParam.endTime = endTime.endOf('day').format('YYYY-MM-DD');
    }
  }
  //日期面板变化时的回调
  onCustomTimeChange2(date: any, dateString: any) {
    let [startTime, endTime] = date;
    this.customTime = [startTime, endTime];
    this.filterParam.startTime = startTime.startOf('day').format('YYYY-MM-DD');
    this.filterParam.endTime = endTime.endOf('day').format('YYYY-MM-DD');
    this.search();
  }
  onTimeRangeTypeChange() {
    if (this.timeRangeType !== '03') {
      this.customTime = [];
      // this.filterParam.startTime = ''
      // this.filterParam.endTime = ''
    }
    this.search();
  }
  //table列表
  async fetchTableData(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      const { data } = await abnormalDetail({
        ...this.filterParam,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { datas, totalNum } = data;
      this.total = Number(totalNum);
      this.tableData = datas;
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  //获取图表数据
  async getTrend() {
    if (this.trendLoading) return;
    this.trendLoading = true;
    this.getParams();
    this.barData = {
      handLift: [],
      special: [],
      repair: [],
      free: []
    };
    //图表折线图数据
    this.lineData = {
      handLift: [],
      special: [],
      repair: [],
      free: []
    };
    this.trendTimeRange = [];
    try {
      const { data } = await abnormalTrend(this.filterParam);
      if (data && data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          this.trendTimeRange.push(data[i].orderDay || '--');
          this.barData.handLift.push(data[i].handelCount || '0');
          this.barData.special.push(data[i].specialCount || '0');
          this.barData.repair.push(data[i].updateCount || '0');
          this.lineData.handLift.push(data[i].handelRate || '0');
          this.lineData.special.push(data[i].specialRate || '0');
          this.lineData.repair.push(data[i].updateRate || '0');
          this.lineData.free.push(data[i].freeRate || '0');
          this.barData.free.push(data[i].freeCount || '0');
        }
      }
      (this.$refs.barLineRef as any).refreshChart();
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.trendLoading = false;
    }
  }
  getPopupContainer() {
    return this.$refs.panel['$el'];
  }
  //重置
  clear({ defaultParkIdList }) {
    this.customTime = [];
    this.selectParkIds = defaultParkIdList;
    this.timeRangeType = '01';
    (this.$refs.rightRank as any).changeType();
  }
  //搜索
  search() {
    this.current = 1;
    this.getOverView();
    this.$nextTick(() => {
      (this.$refs.rightRank as any).getParkRanking();
    });
    this.getTrend();
    this.fetchTableData();
  }
  //手动抬杆列表
  toHandLift(record: any) {
    this.$router.push({
      name: 'HAND_LIFT_RECORD',
      params: {
        parkIds: record.parkId,
        time: record.orderDay
      }
    });
  }
  //特殊放行列表
  toSpecialRecord(record: any) {
    this.$router.push({
      name: 'ORDER_SPECIAL_RECORD',
      params: {
        parkIds: record.parkId,
        time: record.orderDay
      }
    });
  }
  //车辆修正列表
  torepaire(record: any) {
    this.$router.push({
      name: 'REPAIRE_RECORD',
      params: {
        parkIds: record.parkId,
        time: record.orderDay
      }
    });
  }
  //获取搜索条件
  getParams() {
    // 快捷按钮，计算时间范围
    if (this.timeRangeType !== '03') {
      this.customTime = [];
      let startTime, endTime;
      switch (this.timeRangeType) {
        case '01':
          // 近7天
          startTime = moment()
            .startOf('d')
            .subtract(7, 'd');
          endTime = moment()
            .endOf('d')
            .subtract(1, 'd');
          break;
        case '02':
          // 近1月
          startTime = moment()
            .subtract(1, 'd')
            .startOf('d')
            .subtract(1, 'month');
          endTime = moment()
            .subtract(1, 'd')
            .endOf('d');
          break;
        default:
          startTime = moment().startOf('d');
          endTime = moment().endOf('d');
      }
      this.filterParam.startTime = startTime.startOf('day').format('YYYY-MM-DD');
      this.filterParam.endTime = endTime.endOf('day').format('YYYY-MM-DD');
    }
    this.filterParam.parkIds = this.selectParkIds.join(',');
  }
  //概览
  async getOverView() {
    this.getParams();
    try {
      const { data } = await abnormalOverview(this.filterParam);
      const {
        exit,
        handLift,
        handLiftNum,
        inAndOut,
        plateRevise,
        plateReviseNum,
        specialPass,
        specialPassNum,
        freeCount,
        freeCountNum
      } = data;
      this.exit = exit;
      this.handLift = handLift;
      this.handLiftNum = handLiftNum;
      this.inAndOut = inAndOut;
      this.plateRevise = plateRevise;
      this.plateReviseNum = plateReviseNum;
      this.specialPass = specialPass;
      this.specialPassNum = specialPassNum;
      this.freeCount = freeCount;
      this.freeCountNum = freeCountNum;
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    }
  }
  //排名
  // async getParkRanking(sort: string = '00') {
  //   this.getParams()
  //   try {
  //     if (this.rankLoading) return
  //     this.tableLoading = true
  //     let json = { ...this.filterParam, sort: sort }
  //     const { data } = await abnormalParkRanking(json)
  //     this.rankList = data
  //   } catch (error) {
  //     this.$message.error((error && error.msg) || '系统繁忙，请稍后再试')
  //   } finally {
  //     this.tableLoading = false
  //   }
  // }
  created() {
    this.search();
  }
  @Watch('selectParkIds')
  onSelectParkIdChange() {
    this.search();
  }
}
